import InfiniteScroll from 'react-infinite-scroll-component'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { OrderShop } from '@entities/Order'

import { useOfflinePurchasesInfinite } from '@widgets/order-shops-list/model/ useInfiniteOfflinePurchases'


import styles from './styles.module.scss'

export default function OrderShopsList () {
  const { items, hasMore, loadMore } = useOfflinePurchasesInfinite()

  return (
    <InfiniteScroll
      className={styles.root}
      dataLength={items.length}
      next={loadMore}
      hasMore={hasMore}
      loader={
        <SkeletonTheme>
          <Skeleton
            count={3}
            width="100%"
            height={120}
            style={{ borderRadius: 16, marginBottom: 20 }}
          />
        </SkeletonTheme>
      }
    >
      {items.map((item, index) => (
        <OrderShop
          key={`${item?.id}-${index}`}
          data={item}
          isInitialOpen={index === 0}
        />
      ))}
    </InfiniteScroll>
  )
}
